const awards = {
    wins: 0,
    nominations: 0,
    prestigeAward: {
        name: "",
        wins: 0,
        nominations: 0
    }
}

export default awards;